<template>
  <modal
    v-if="value"
    hide-footer
    :title="$t('changeLanguage.title')"
    :value="value"
    @input="(e) => $emit('input', e)"
  >
    <p>
      <small> {{ $t("changeLanguage.description") }}</small>
    </p>
    <div class="row s-change-language">
      <div
        class="es-xs-6 es-sm-4"
        v-for="(locale, i) in $i18n.availableLocales"
        :key="i"
        @click="SET_LOCALE(locale)"
      >
        <div
          class="o-card s-change-language__item u-hover-select"
          :class="{
            's-change-language__item--active': locale === $i18n.locale,
          }"
        >
          <img
            class="s-change-language__item__image"
            :src="`https://flagicons.lipis.dev/flags/4x3/${
              locale === 'en' ? 'gb' : locale || 'tr'
            }.svg`"
            width="100%"
            :alt="locale"
          />
        </div>
      </div>
    </div>
    <p>
      <small
        ><i class="icofont-info-circle"></i>
        {{ $t("changeLanguage.warnforDynamicData") }}</small
      >
    </p>
  </modal>
</template>

<script>
import Modal from "@/components/Base/Modal.vue";

export default {
  components: { Modal },
  props: {
    value: {
      default: false,
    },
  },
  watch: {
    value(data) {
      if (!data) document.body.classList.remove("overflow-hidden");
    },
  },
  methods: {
    SET_LOCALE(locale) {
      // this.$i18n.setLocale(locale);
      this.$i18n.locale = locale;
      localStorage.setItem("lang", locale);
      location.reload();
      this.$emit("input", false);
    },
  },
  mounted() {
    console.log(this.$t("changeLanguage.languageIsChanged"), this.$i18n);
  },
};
</script>
